import React from 'react';
import './TokenBox.css';
import CopyToClip from '../../infra/CopyToClip';

export default function TokenBox({token, envVar}) {
  const sample='*********'+token?.slice(-5); // last 5 chars...
  const text=envVar ? `SET ${envVar.toUpperCase()}="${sample}"`: sample;

  return (
    <div className='tokenBox'>
      <div className='codeTerminal' style={{flexGrow: 1}}>
        {text}
      </div>
      <CopyToClip text={token}/>
    </div>
  )
}
